import DimensionDetailsCard from "./dimension-details-card";
import AnnualPerformanceCard from "./performance-grid/annual-performance-card";
import CompanyResultCard from "./performance-grid/company-result-card";
import PerformanceByDimensionCard from "./performance-grid/performance-by-dimension-card";
import RelevantTopicsCard from "./performance-grid/relevant-topics-card";
import SectorPositioningCard from "./performance-grid/sector-positioning-card";
import ResultsSummary from "./results-summary";

const GeneralIndicatorsPage = () => {
  return (
    <div className="flex flex-col gap-6">
      <ResultsSummary />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-6">
        <CompanyResultCard className="lg:col-span-2" />

        <AnnualPerformanceCard className="lg:col-span-4" />

        <SectorPositioningCard className="lg:col-span-3" />

        <PerformanceByDimensionCard className="lg:col-span-3" />

        <RelevantTopicsCard className="lg:col-span-6" />
      </div>

      <DimensionDetailsCard />
    </div>
  );
};

export default GeneralIndicatorsPage;
